import axios from 'axios'
import api from '@/api/api'
import state from '@/store/module_principal/state'
export default {
  clientinfo(ip) {
    return axios.get("https://ipapi.co/"+ip+"/json/").then(result => result.data) 
  },
  login (usuario, localizacao) {
    var info = {
      username: usuario.username,
      password: usuario.password,
      cidade: usuario.cidade,
      abrvCorporacao: usuario.abrvCorporacao,
      ip: localizacao.ip,
      street: localizacao.street,
      city: localizacao.city,
      region: localizacao.region,
      region_code: localizacao.region_code,
      country: localizacao.country,
      country_code: localizacao.country_code,
      country_name: localizacao.country_name,
      latitude: localizacao.latitude,
      longitude: localizacao.longitude,
      timezone: localizacao.timezone,
      org: localizacao.org,
      browser_name: localizacao.browser_name,
      browser_version: localizacao.browser_version,
      os_name: localizacao.os_name,
      is_mobile: localizacao.is_mobile,
      mobile_model: localizacao.mobile_model,
      mobile_factory: localizacao.mobile_factory
    }
    var transferencia = { token: api.aesEncrypt(JSON.stringify(info)) }
    return axios.post(state.ip.protocolo + "://" + state.ip.backendIp + state.ip.backendPort + "/", transferencia, {
    //return axios.post("http://192.168.40.120:5004/" , transferencia, {
        withCredentials: true,
        crossorigin: true,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded"
        }
    }).then(result => result.data)
  },
}